<template>
    <div class="slm-history-map__map--wrapper" >
        <GoogleMap
            v-if="cookieAccepted"
            id="history-map"
            ref="map"  
            class="slm-history-map__map"
            :api-key="key"
            :map-id="mapId"
            :styles="styles"
            :disable-default-ui="true"
            :map-type-id="view"
            :center="position" 
            :zoom="zoom"  
            @click="windowOpen = false"
            @dragend="centerChanged()"
            @zoom_changed="zoomChanged()"
            style="width: 100%; height: 100%;"
        >
            <MarkerCluster v-if="isMounted" :options="clusterOptions" >
                <Marker 
                    v-for="history in histories" 
                    :key="history.url" 
                    :options="{
                        position: history.position,
                        icon: getIcon(history.color)
                    }" 
                    @click="markerClick(history)"
                >
                </Marker>
            </MarkerCluster>
            <Marker 
                v-show="(userLocation && userLocationOpen)"
                :options="{ icon: userLocationIcon, position: userLocation }"
            >
            </Marker>
            <Marker
                v-if="selectedHistory && selectedHistoryOpen"
                :options="{ icon: getIcon('black'), position: selectedHistory.position, zIndex: 999 }"
            >
            </Marker>
            <CustomControl class="slm-history-map__map--custom-controls" position="RIGHT_BOTTOM">
                <div class="slm-history-map__map--zoom-control">
                    <button class="slm-history-map__map--zoom zoom-in" @click="setZoom(1)"><span class="show-for-sr">Zooma in</span></button>
                    <span class="slm-history-map__map--zoom-border"></span>
                    <button class="slm-history-map__map--zoom zoom-out" @click="setZoom(-1)"><span class="show-for-sr">Zooma ut</span></button>
                </div>
                <button class="slm-history-map__map--user-location" @click="getUserLocation()"><span class="show-for-sr">Visa min position</span></button>
            </CustomControl>
        </GoogleMap>
        <div class="slm-history-map__cookie" v-else>
            <h2>För att använda kartan måste du acceptera funktionella cookies.</h2>
            <p>Ladda om sidan när du uppdaterat dina cookie-inställningar för visa kartan.</p>
            <button class="slm-link-button cky-banner-element">Redigera cookie-inställningar</button>
        </div>
        <div v-if="selectedHistory && selectedHistoryOpen" class="slm-history-map__map--info" :aria-expanded="selectedHistory && selectedHistoryOpen ? 'true' : 'false'">
            <button class="slm-history-map__map--info__close" @click="closeSelectedClick()">
                <span class="show-for-sr">Stäng info-fönster</span>
            </button>
            <a class="slm-history-map__map--info__link" :href="selectedHistory.url">
                <p class="slm-history-map__map--info__title">{{selectedHistory.title}}</p>
            </a>
            <div class="slm-history-map__map--info__image-wrapper" v-html="selectedHistory.image ? selectedHistory.image : fallbackImage"></div>
        </div>
    </div>
</template>

<script>
import { GoogleMap, Marker, MarkerCluster, CustomControl } from 'vue3-google-map';

export default {
    name: 'map-component',
    data() {
        return {
            userLocationOpen: false,
            userLocation: false,
            map: null,
            selectedHistoryOpen: false,
            isMounted: false,
        }
    },
    watch: {
        filtersChanged() {
            this.centralize();
        }
    },
    methods: {
        closeSelectedClick() {
            this.$store.commit('setSelectedHistory', null);
            this.selectedHistoryOpen = false;
            this.$store.dispatch('setUrl');
        },
        markerClick(des) {
            this.$store.commit('setSelectedHistory', des.id);
            this.$store.commit('setPosition', des.position)
            this.selectedHistoryOpen = true;
            this.$store.dispatch('setUrl');
        },
        centerChanged() {
            this.$store.commit('setPosition', { lat: this.map.map.center.lat(), lng: this.map.map.center.lng() });
            this.$store.dispatch('setUrl');
        },
        setZoom(num) {
            this.$store.commit('setZoom', this.zoom + num);
        },  
        zoomChanged() {
            this.$store.commit('setZoom', this.map.map.zoom);
            this.$store.dispatch('setUrl');
        },
        getUserLocation() {
            const navigator = window.navigator;
            const _this = this;
            if(navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((position) => {
                    const pos = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    }
                    this.$store.commit('setPosition', pos);
                    _this.userLocation = pos;
                    _this.userLocationOpen = true;
                },
                () => {
                    this.handleGeoLocationError(true);
                })
            } else {
                this.handleGeoLocationError(false);
            }
        },
        handleGeoLocationError(browserHasSupport) {
            if(browserHasSupport) {
                alert('Saknar tillåtelse att hämta din plats')
            } else {
                alert('Din browser har inte stöd för att hämta din plats')
            }
        },
        getIcon(color) {
            const svgMarker = {
                path: "M9.76685 6.73375L9.76625 6.73315C9.28126 6.24897 8.68351 6 8 6C7.31646 6 6.71889 6.249 6.23445 6.73345C5.74952 7.21838 5.5 7.81621 5.5 8.5C5.5 9.18367 5.74944 9.78123 6.23445 10.2656C6.71877 10.7506 7.31633 11 8 11C8.68379 11 9.28162 10.7505 9.76655 10.2656C10.251 9.78111 10.5 9.18354 10.5 8.5C10.5 7.81649 10.251 7.21874 9.76685 6.73375ZM2.40217 13.8569L2.40206 13.8567C1.11023 11.9482 0.5 10.233 0.5 8.7C0.5 6.31773 1.26101 4.46736 2.75194 3.09258L2.75202 3.09251C4.27109 1.69121 6.01355 1 8 1C9.98645 1 11.7289 1.69121 13.248 3.09251L13.2481 3.09258C14.739 4.46736 15.5 6.31773 15.5 8.7C15.5 10.2331 14.8901 11.9483 13.5989 13.8568C12.3609 15.6864 10.5001 17.6815 8 19.8414C5.49991 17.6815 3.63949 15.6864 2.40217 13.8569Z",
                fillColor: color || this.iconDefaultColor || '#FECA33',
                fillOpacity: 1,
                strokeWeight: 1.5,
                rotation: 0,
                scale: 2,
                anchor: { x: 8, y: 21 },
            };
            return svgMarker;
        },
        centralize() {
            if(this.map.ready) {
                const bounds = new this.map.api.LatLngBounds();
                this.histories.forEach((history) => {
                    bounds.extend(new this.map.api.LatLng(history.position.lat, history.position.lng))
                })
                this.map.map.fitBounds(bounds);
            }
        }
    },
    computed: {
        filtersChanged() {
            return this.$store.state.filtersChanged;
        },
        cookieAccepted() {
            return this.$store.state.cookieAccepted;
        },
        mapId() {
            return this.$store.state.mapId;
        },
        selected() {
            return this.$store.state.selected;
        },
        key() {
            return this.$store.state.mapKey;
        },
        histories() {
            return this.$store.state.filteredHistories
        },
        distPath() {
            return this.$store.state.distPath
        },
        fallbackImage() {
            return this.$store.state.fallbackImage;
        },
        iconDefaultColor() {
            return this.$store.state.iconDefaultColor;
        },
        position() {
            return this.$store.state.position;
        },
        zoom() {
            return this.$store.state.zoom;
        },
        view() {
            return this.$store.state.view;
        },
        selectedHistory() {
            return this.$store.state.histories.find(history => history.id === this.selected);
        },
        clusterOptions() {
            if(this.map.ready) {
                return {
                    renderer: {
                        render: ({count, position}) => {
                            return new this.map.api.Marker({
                                position,
                                icon: {
                                    url: this.distPath + 'map-cluster.png',
                                    scaledSize: new this.map.api.Size(50, 50),
                                    anchor: { x: 25, y: 25 }
                                },
                                label: {
                                    text: count.toString(),
                                    color: '#000',
                                    fontSize: '1rem',
                                    fontWeight: '700',
                                    margin: 0,
                                    lineHeight: 1,
                                },
                                optimized: true,
                                zIndex: new this.map.api.Marker().MAX_ZINDEX + count
                            })
                        }
                    }
                }
            } else {
                return {}
            }
        },
        userLocationIcon() {
            return {
                url: this.$store.state.userLocationIcon,
                anchor: { x: 47, y: 47 },
            }
        },
    },
    mounted() {
        this.map = this.$refs.map;
        this.isMounted = true;
    },
    created() {
        this.selectedHistory ? this.selectedHistoryOpen = true : this.selectedHistoryOpen = false;
    },
    components: {
        GoogleMap,
        Marker,
        MarkerCluster,
        CustomControl
    }
}
</script>